import { render, staticRenderFns } from "./CorrectDemand.vue?vue&type=template&id=3e91eaf8&scoped=true&"
import script from "./CorrectDemand.vue?vue&type=script&lang=js&"
export * from "./CorrectDemand.vue?vue&type=script&lang=js&"
import style0 from "./CorrectDemand.vue?vue&type=style&index=0&id=3e91eaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91eaf8",
  null
  
)

export default component.exports